import apiService from '@/api/apiService';
import { handleHttpError } from '@/api/errorHandler';

/**
 * 複製資產負債表版本
 * @param {number} id - 要複製的版本 ID
 * @param {Object} payload - 複製時的額外參數
 * @returns {Promise<Object>} API 回應
 */
export const copyVersion = async (id, payload = {}) => {
    try {
        const url = `/api/admin/balance/version/copy/${id}`;
        return await apiService.POST(url, payload);
    } catch (error) {
        throw handleHttpError(error, url, 'POST');
    }
};
